// Module
var code = "<span class=\"status\" title=\"Acknowledged environments\"><i class=\"acknowledged icon\"></i>{{ $ctrl.status.acknowledged || 0 }}</span>\n<span class=\"status\" title=\"Successful environments\"><i class=\"ok icon\"></i>{{ $ctrl.status.ok || 0 }}</span>\n<span class=\"status\" title=\"Failed environments\"><i class=\"error icon\"></i>{{ $ctrl.status.error || 0 }}</span>\n";
// Exports
var _module_exports = code;;
var path = 'app/edge/components/edge-stack-status/edgeStackStatus.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;